import { Component, ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { environment } from '../../../environments/environment';
import { storageAvailable } from '../../util/helpers';
import { MatCheckboxChange } from '@angular/material';
import { HistoryTrackerService } from '../../shared/history-tracker/history-tracker.service';
import { PinSearchbarService } from '../../shared/services/pin-searchbar.service';

@Component({
  selector: 'app-event-page',
  templateUrl: './event-page.component.html',
  styleUrls: ['./event-page.component.scss']
})
export class EventPageComponent implements OnInit {
  aviationEvent: AviationEvent;
  isPinChecked = false;

  constructor(private _route: ActivatedRoute,
              private _router: Router,
              private _meta: Meta,
              private _title: Title,
              private _history: HistoryTrackerService,
              private _errorHandler: ErrorHandler,
              private _pinSearchbarService: PinSearchbarService) { }

  ngOnInit() {
    if (storageAvailable('localStorage')) {
      const storageVal = localStorage.getItem('searchbarPinned');
      this.isPinChecked = storageVal === 'true';
    }
    this._route.data
      .subscribe((data: { aviationEvent: AviationEvent }) => {
        this.aviationEvent = data.aviationEvent;
        this._updateMeta(data.aviationEvent);
      }, (error: any) => {
        this._errorHandler.handleError(error);
      });
  }

  private _updateMeta(aviationEvent: AviationEvent) {
    const title = aviationEvent.title;
    this._title.setTitle(`${title} - ${environment.appName}`);
    this._meta.removeTag('name="description"');
  }

  cameFromSearch(): boolean {
    return (this._history.previousUrl && this._history.previousUrl.startsWith('/search'));
  }

  onClickBack (event: MouseEvent) {
    event.preventDefault();
    if (this._history.previousUrl && this._history.previousUrl.startsWith('/search')) {
      this._router.navigateByUrl(this._history.previousUrl);
      return;
    }
    this._router.navigate(['/search'], { queryParams: { 'public': 1 } });
  }

  onClickNewSearch (event: MouseEvent) {
    event.preventDefault();
    this._router.navigate(['/'], { queryParams: { 't': 'events' } });
  }

  onChange (ob: MatCheckboxChange) {
    this.isPinChecked = ob.checked;
    if (storageAvailable('localStorage')) {
      localStorage.setItem('searchbarPinned', '' + this.isPinChecked);
    }
    this._pinSearchbarService.pinSearchbarClicked(this.isPinChecked);
  }

}
